import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { UploadFileContactInformation } from 'src/app/pages/contact-information/model/potential-customer';
import { loadPremisesPhotos, resetPremisesPhotos } from '../actions/contact-information.actions';

const initialState: UploadFileContactInformation = {
    uploadFile0: [],
    uploadFile1: [],
};

const getUploadFileContactInformationState = createFeatureSelector<UploadFileContactInformation>('UploadFileContactInformationInfo');

export const getPremisesPhoto = createSelector(getUploadFileContactInformationState, (state) => state);

export const uploadFileOptionalReducer = createReducer<UploadFileContactInformation>(
  initialState,
  on(loadPremisesPhotos, (state, props): UploadFileContactInformation => ({ ...state, ...props.uploadFileContactInformationInfo })),
  on(resetPremisesPhotos, () => initialState),
);